/**
 * 
 * 
 * 
 */

/**
 * Promoción de noviembre: 20 % en las visitas con fecha de noviembre.
 * El código de descuento tiene que existir en Shopify (Descuentos), limitado a los productos de visitas.
 * Al añadir al carrito entradas con fecha dentro de `month`, se aplica el código automáticamente.
 */
const VISIT_PROMO = {
    code:    "VISITASNOVIEMBRE20",
    month:   "2026-11",    // YYYY-MM de la fecha de la visita
    endDate: "2026-11-30", // Último día en que se muestra el anuncio
    text:    "Reserva tu visita para noviembre y disfruta de un 20 % de descuento.",
    applied: "Descuento del 20 % aplicado automáticamente en el carrito.",
};

class VisitSelector extends HTMLElement {
    constructor() {
        super();
        this.productId = null;
        this.mode      = null;
        this.attachShadow({ mode: 'open' }); // Attach a shadow root to the element
        this.shadowRoot.innerHTML = `
            <style>
                .ticket-wrapper {
                    border: solid .7px;
                }
                .ticket-image-wrapper {
                    display: flex;
                    align-items: center;
                    border-bottom: solid 0.7px;
                    justify-content: space-between;
                    padding-right: 10px;
                    padding: 10px;
                    flex-wrap: wrap;
                }
                @media screen and (max-width: 1241px) {
                    .ticket-image-wrapper {
                        justify-content: center !important;
                    }
                }
                @media screen and (min-width: 444px) and (max-width: 600px) {
                    .ticket-image-wrapper {
                        justify-content: space-between !important;
                    }
                }
                .ticket-image-wrapper img {
                    max-width: 50px;
                    padding: 5px
                }
                .ticket-form {
                    padding: 15px;
                }
                .ticket-selector-wrapper, .ticket-quantity-selector-wrapper {
                    display: flex;
                    flex-direction: column;
                }
                select, input {
                    padding: 7px;
                    font-size: 13px;
                }
                .ticket-selector-wrapper {
                    margin-bottom: 12px;
                }
                .ticket-quantity-selector-wrapper {
                    margin-bottom: 20px;
                }
                .ticket-select-date-button {
                    padding: 10px;
                    font-size: 13px;
                }
                .alert-warning {
                    color: #c21f1f;
                    padding: 1px 4px;
                }
                .quantity-stock {
                    color: gray;
                    font-size: 12px;
                }
                .ticket-data-wrapper {
                    display: flex;
                    align-items: center;
                }
                .ticket-select-date, .alert {
                    text-align: center;
                }
                .block-quantity-with-label {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-items: center;
                }
                .ticket-quantity-select {
                    flex: 1;
                }
                .promo-banner {
                    text-align: center;
                    font-weight: 600;
                    margin-bottom: 15px;
                }
                .alert-promo {
                    color: #2e7d32;
                    padding: 1px 4px;
                }
            </style>
        `
        this.contentElement = document.createElement("content");
        this.shadowRoot.appendChild(this.contentElement);
    }

    connectedCallback() {
        this.productId = this.getAttribute("product-id")   || "NO-ID";

        console.log("this.productData", this.productId);

        this.contentElement.innerHTML = "<p>Loading...</p>"; // Default content
        this.getColorSelectorContent();
    }


    
    async getColorSelectorContent() {
      
        let listLenguajes = {
            "lan_es" : "Español",
            "lan_en" : "Ingles",
            "lan_fr" : "Frances",
        }
      
        if (this.productId === "NO-ID") {
            return this.contentElement.innerHTML = `GIVE ME A group_id ATTRIBUTE`;
        }
        
        let fetchRes   = await fetch(`https://visits.tible.tech/public-auth/product-selector/${Shopify.shop}/${this.productId}`);
        let parsedData = await fetchRes.json();
        let languagesData = parsedData.visitData.languages;
      
        
        if (!parsedData.ok) {
            return;
        }
      
        if(languagesData.length == null) {
          return;
        }
        
        this.options = [];
        for(let lenguaje of languagesData) {
          if (listLenguajes[lenguaje]) {
            this.options.push({
                innerHTML: listLenguajes[lenguaje], 
                value: `${lenguaje}`.replace("lan_", ""),
            });
          }
          
        }

        this.visitData   = parsedData.visitData;
        this.productData = parsedData.productData;
        this.renderElement();
    }

    renderElement() {
        this.contentElement.innerHTML = ``;
        let ticketWrapper = this.createNode("div", ["ticket-wrapper"]);
            let ticketImageWrapper = this.createNode("div", ["ticket-image-wrapper"]);
            ticketWrapper.appendChild(ticketImageWrapper);
            let ticketDataWrapper =  this.createNode("div", ["ticket-data-wrapper"]);
                ticketDataWrapper.innerHTML = `
                    <img src="https://visits.tible.tech/${this.visitData.images[0].location}"/>
                    <div>
                        <div style="font-size: 19px;font-weight: 600;">
                            Visita guiada
                        </div>
                        <div>
                            
                        </div>
                    </div>
                `
            ticketImageWrapper.appendChild(ticketDataWrapper);

            let ticketDateSelectorWrapper = this.createNode("div", ["ticket-date-selector-wrapper"]);
                let dateSelector = this.createNode("input", ["ticket-select-date-button"], {type: "date", min: this.formatDateToYearMonthDayDateString(new Date)});
                dateSelector.addEventListener("change", () => this.updateCalendar());
                this.dateSelector = dateSelector;
                ticketDateSelectorWrapper.appendChild(dateSelector);
            ticketImageWrapper.appendChild(ticketDateSelectorWrapper);

            let slotOptions = this.visitData.slot;
            this.slotOptionsArray = slotOptions.split('\n');
            
            let ticketSlotSelectorWrapper =  this.createNode("div", ["ticket-selector-wrapper"]);
                //ticketSlotSelectorWrapper.appendChild(this.createNode("label", ["ticket-selector-label"], {htmlFor: "slot-selector", innerHTML: "¿En qué franja horaria desea acudir?"}));
                let ticketSlotSelector = this.createNode("select", ["ticket-selector"], {id: "slot-selector", style: "margin-top: 5px;"});
                this.slotOptionsArray.forEach((optionValue) => {
                    ticketSlotSelector.appendChild(this.createNode("option", [], {textContent: optionValue, value: optionValue}));
                });
                this.ticketSlotSelector = ticketSlotSelector;
                ticketSlotSelector.addEventListener("change", () => this.updateCalendar());
                ticketSlotSelectorWrapper.appendChild(ticketSlotSelector);
            ticketDateSelectorWrapper.appendChild(ticketSlotSelectorWrapper);

            let ticketForm = this.createNode("div", ["ticket-form"]);
            ticketWrapper.appendChild(ticketForm);

            if (this.isPromoActive()) {
                ticketForm.appendChild(this.createNode("div", ["promo-banner"], {textContent: VISIT_PROMO.text}));
            }

            let ticketLanguageSelectorWrapper =  this.createNode("div", ["ticket-selector-wrapper"]);
                ticketLanguageSelectorWrapper.appendChild(this.createNode("label", ["ticket-selector-label"], {htmlFor: "language-selector", innerHTML: "Idioma"}));
                let ticketLanguageSelector = this.createNode("select", ["ticket-selector"], {id: "language-selector"});
                this.options.forEach((optionValue) => {
                  console.log("El valor que recibimos de optionValue ",optionValue);
                    ticketLanguageSelector.appendChild(this.createNode("option", [], {...optionValue}));
                    console.log("mosntrando los lenguajes");
                })
                this.languageSelector = ticketLanguageSelector;
                ticketLanguageSelector.addEventListener("change", () => this.updateCalendar());
                ticketLanguageSelectorWrapper.appendChild(ticketLanguageSelector);
            ticketForm.appendChild(ticketLanguageSelectorWrapper);
            

            let ticketQuantitySelectorWrapper = this.createNode("div", ["ticket-quantity-selector-wrapper"]);
                let quantityLabel = this.createNode("label", ["ticket-quantity-label"], {htmlFor: "quantity-selector", innerHTML: "Reserva de entradas"});
                this.quantityLabel = quantityLabel;
                ticketQuantitySelectorWrapper.appendChild(quantityLabel);
                
                let contentAdult = this.createNode("div", ["block-quantity-with-label"]);
                this.contentAdult = contentAdult;
                ticketQuantitySelectorWrapper.appendChild(contentAdult);
                
                let adultLabel = this.createNode("label", ["ticket-quantity-select"], {innerHTML: "Entradas para adultos ("+parseInt(this.visitData.price, 10)+" €): "});
                this.adultLabel = adultLabel;
                contentAdult.appendChild(adultLabel);
                let quantitySelectorAdult = this.createNode("input", ["ticket-select-date-button"], {type: "number", style: "margin-top: 5px; max-width: 90px;"});
                this.quantitySelectorAdult = quantitySelectorAdult;
                contentAdult.appendChild(quantitySelectorAdult);

                let contentChildren = this.createNode("div", ["block-quantity-with-label"]);
                this.contentChildren = contentChildren;
                ticketQuantitySelectorWrapper.appendChild(contentChildren);
                
                let childrenLabel = this.createNode("label", ["ticket-quantity-select"], {innerHTML: "Entradas para niños: ("+parseInt(this.visitData.price_children, 10)+" €)"});
                this.childrenLabel = childrenLabel;
                contentChildren.appendChild(childrenLabel);
                let quantitySelectorChildren = this.createNode("input", ["ticket-select-date-button"], {type: "number", style: "margin-top: 5px; max-width: 90px;"});
                this.quantitySelectorChildren = quantitySelectorChildren;
                contentChildren.appendChild(quantitySelectorChildren);
                
            ticketForm.appendChild(ticketQuantitySelectorWrapper);

            let ticketAddToCart = this.createNode("div", ["ticket-select-date"]);
                let addToCartButton = this.createNode("button", ["ticket-select-date-button"], {innerHTML: "Comprar entradas"});
                this.addToCartButton = addToCartButton;
                let addingToCart = false;
                addToCartButton.addEventListener("click", async () => {
                    if (addingToCart) return;
                    addingToCart = true;
                    let addToCartResponse = await this.addToCart();
                    if (addToCartResponse === true) {
                        return window.location = await this.getCartRedirectUrl();
                    } 
                    addingToCart = false;
                    this.ticketMessages.innerHTML = `<div class="alert alert-warning">Se ha producido un error al añadir al carrito (${addToCartResponse}).</div>`
                });
                ticketAddToCart.appendChild(addToCartButton);
            ticketForm.appendChild(ticketAddToCart);

            let ticketMessages = this.createNode("div", ["ticket-messages-wrapper"]);
            this.ticketMessages = ticketMessages;
            ticketForm.appendChild(ticketMessages);

            let quantityStock = this.createNode("span", ["ticket-messages-quantity-stock"]);
            this.quantityStock = quantityStock;
            ticketQuantitySelectorWrapper.appendChild(quantityStock);

        this.updateCalendar();

        this.contentElement.appendChild(ticketWrapper);
    }

    formatDateToYearMonthDayDateString(date) {
        const year = String(date.getFullYear());
        let month = String(date.getMonth() + 1);
        let day = String(date.getDate());
        if (month.length < 2) {
            month = String(month).padStart(2, "0");
        }
        if (day.length < 2) {
            day = String(day).padStart(2, "0");
        }
        return [year, month, day].join("-");
    }

    getSelectedQuantity(type) {
        if (type == "adult") {
            return this.quantitySelectorAdult.value;
        } else {
            return this.quantitySelectorChildren.value;      
        }
    }

    getSelectedSlot() {
        return this.ticketSlotSelector.value;
    }
    
    getSelectedDate() {
        return this.dateSelector.value;
    }

    getSelectedLanguage() {
        return this.languageSelector.value;
    }

    async updateCalendar() {

        this.ticketMessages.innerHTML          = ``;
        this.quantityLabel.innerHTML           = `Reserva de entradas`;
        this.addToCartButton.disabled          = true;
        this.quantitySelectorAdult.disabled    = true;
        this.quantitySelectorChildren.disabled = true;
        let slotSelector                       = this.ticketSlotSelector;
        slotSelector.style.display             = "block";

        let selectedSlot     = this.getSelectedSlot();
        let selectedDate     = this.getSelectedDate();
        let selectedLanguage = this.getSelectedLanguage();
        
        
        if (selectedDate == '') {
            slotSelector.style.display = "none";
            return this.ticketMessages.innerHTML = `<div class="alert alert-warning">Por favor, selecciona una fecha.</div>`
        }
        
        let jsonData = JSON.stringify(
            {
                date: selectedDate,
                language: selectedLanguage,
            }
        );
        jsonData = btoa(jsonData);

        let fetchRes   = await fetch(`https://visits.tible.tech/public-auth/check-dates/${Shopify.shop}/${this.productId}/${jsonData}`, {
            method: "GET", 
        });
        
        let parsedData = await fetchRes.json();
        if (!parsedData.ok) {
            return;
        }

        
        if (parsedData.selectionResponse.avialableSpots > 0) {
            this.quantityLabel.innerHTML           += `<span class="quantity-stock"> (`+parsedData.selectionResponse.avialableSpots +` disponibles)</span>`
            this.quantitySelectorAdult.disabled    = false;
            this.quantitySelectorChildren.disabled = false;
            this.addToCartButton.disabled          = false;
            this.quantitySelectorAdult.max         = parsedData.selectionResponse.avialableSpots;
            this.quantitySelectorAdult.min         = 0;
            this.quantitySelectorChildren.max      = parsedData.selectionResponse.avialableSpots;
            this.quantitySelectorChildren.min      = 0;
            if (this.isPromoDate(selectedDate)) {
                this.ticketMessages.innerHTML = `<div class="alert alert-promo">${VISIT_PROMO.applied}</div>`
            }
        } else if (parsedData.selectionResponse.avialableSpots == "DATE_NOT_ALLOWED") {
            this.ticketMessages.innerHTML = `<div class="alert alert-warning">Este día no se admiten reservas.</div>`
        } else if (parsedData.selectionResponse.avialableSpots == "LANGUAGE_MISMATCH") {
            this.ticketMessages.innerHTML = `<div class="alert alert-warning">Este día no está disponible en este idioma.</div>`
        } else {
            this.ticketMessages.innerHTML = `<div class="alert alert-warning">No hay entradas disponibles.</div>`
        }

    }

    isPromoActive() {
        return this.formatDateToYearMonthDayDateString(new Date) <= VISIT_PROMO.endDate;
    }

    isPromoDate(date) {
        return `${date}`.startsWith(VISIT_PROMO.month + "-");
    }

    /**
     * Devuelve a dónde ir tras añadir al carrito. Si todas las visitas del carrito son del mes
     * de la promoción, pasa por /discount/CODIGO para aplicar el descuento. Si hay visitas de otras
     * fechas, quita el código para que no se aplique a ellas.
     */
    async getCartRedirectUrl() {
        try {
            let cart       = await (await fetch("/cart.js")).json();
            let visitDates = cart.items.map(item => item?.properties?.Fecha).filter(Boolean);
            let allPromo   = visitDates.length > 0 && visitDates.every(date => this.isPromoDate(date));
            if (allPromo) {
                return `/discount/${encodeURIComponent(VISIT_PROMO.code)}?redirect=/cart`;
            }
            let codeApplied = (cart.discount_codes || []).some(({code}) => `${code}`.toUpperCase() === VISIT_PROMO.code);
            if (codeApplied) {
                let otherCodes = cart.discount_codes.map(({code}) => code).filter(code => `${code}`.toUpperCase() !== VISIT_PROMO.code);
                await fetch("/cart/update.js", {
                    method: "POST",
                    headers: {"content-type": "application/json"},
                    body: JSON.stringify({discount: otherCodes.join(",")}),
                });
            }
        } catch (error) {
            console.warn("No se ha podido comprobar el descuento de visitas", error);
        }
        return "/cart";
    }

    getSelectedVariantId(type) {
        if (!this.productData?.variants?.edges) {
            return false;
        }
        let selectedVariant = this.productData.variants.edges.find(({node: {selectedOptions}}) => {
            if (type == "adult") {
                return `${selectedOptions[0].value}`.toLowerCase() === `${this.getSelectedLanguage()}`.toLowerCase()+" adulto";
            } else {
                return `${selectedOptions[0].value}`.toLowerCase() === `${this.getSelectedLanguage()}`.toLowerCase()+" menor";
            }
        })
        return selectedVariant?.node?.id;
    }

    async addToCart() {

        if (!this.productData?.id) {
            return "No podemos encontrar el product ID";
        }
        
        let selectedVariantId = [
            { type: "adult", id: this.getSelectedVariantId("adult") },
            { type: "children", id: this.getSelectedVariantId("children") }
        ];

       
        if (!selectedVariantId) {
            return "No podemos encontrar el product variant ID";
        }
        
        let selectedQuantityAdult    = this.getSelectedQuantity("adult");
        let selectedQuantityChildren = this.getSelectedQuantity("children");

        let totalQuantitySelected = parseInt(selectedQuantityAdult, 10)+parseInt(selectedQuantityChildren, 10);

        if (totalQuantitySelected > this.quantitySelectorChildren.max) {
            return "Has seleccionado más entradas de las disponibles";
        }

        if (!selectedQuantityAdult && !selectedQuantityChildren) {
            return "Selecciona al menos una entrada";
        }

        let productId             = `${this.productData.id}`.replace("gid://shopify/Product/", "");
        let selectedDate          = this.getSelectedDate();
        let selectedSlot          = this.getSelectedSlot();
        let allRequestsSuccessful = true;

        for (let variantId of selectedVariantId) {
            let productVariantId = `${variantId.id}`.replace("gid://shopify/ProductVariant/", "");
            let quantityVariant = variantId.type === "adult" ? selectedQuantityAdult : selectedQuantityChildren;
            if (quantityVariant < 1) {
                continue;
            }
            
            let formDataObject = {
                "form_type": "product",
                "utf8": "✓",
                "id": productVariantId,
                "quantity": quantityVariant,
                "product-id": productId,
                "properties[Fecha]": selectedDate,
                "properties[Hora]": selectedSlot,
            };

            let rawResponse = await fetch("/cart/add.js", {
                headers: {
                    "accept": "text/plain, */*; q=0.01",
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "pragma": "no-cache",
                    "sec-fetch-mode": "cors",
                    "sec-fetch-site": "same-origin",
                    "x-requested-with": "XMLHttpRequest"
                },
                referrerPolicy: "strict-origin-when-cross-origin",
                body: new URLSearchParams(formDataObject).toString(),
                method: "POST",
                mode: "cors",
                credentials: "include"
            });

            if (rawResponse.status !== 200) {
                allRequestsSuccessful = false;
                break; // Si una solicitud falla, salimos del bucle
            }
        }

        if (allRequestsSuccessful) {
            return true;        
        }
        return false;

    }


    /**
     * 
     * Función de ayuda para simplificar la creación de Nodos
     * 
     * @param {String} type Tipo de nodo a crear
     * @param {String[Array]} classArray Clases que queremos añadir a nuestro elemento
     * @param {Object} options Opciones extra a añadir a nuestro elemento
     * @returns 
     */
    createNode(type, classArray = [], options = {}) {
        let node = document.createElement(type);
        // Asignamos todas las características de nuestro objeto al nodo creado 
        for (let [optionKey, optionValue] of Object.entries(options)) {
            node[optionKey] = optionValue;
        }
        
        // Asignamos las clases controlando errores
        classArray.map(singleClass => {
            try {
            node.classList.add(singleClass); 
            } catch (error) {
                console.warn(node, `Could not add the class ${singleClass} to the classList node`);
            }
        });      
        return node;
    }

}

customElements.define('visit-selector', VisitSelector);
